import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { AMPLITUDE_EVENT_TYPES } from 'constants/amplitude';
import notify from 'utils/notificationUtils';
import useTranslation from 'utils/hooks/useTranslation';
import { convertDataToPDF } from '../../pages/SalesforceInvoices/helper';
import {
  getSalesforceInvoicesList,
  getSalesforceInvoiceDocument,
} from 'services/api/salesforceInvoices';
import useAmplitude from 'utils/hooks/useAmplitude';

export const useGetSalesforceInvoicesList = payload => {
  const { translateText } = useTranslation();
  const corporateClientId = useSelector(state => state.user.corporateClientId);
  const getInvoiceSummarylist = async () => {
    const result = await getSalesforceInvoicesList(payload);
    return result?.data;
  };

  return useQuery({
    queryKey: ['salesforceInvoices', corporateClientId, payload],
    queryFn: getInvoiceSummarylist,
    enabled: !!(payload?.startDate && payload?.endDate),
    retry: false,
    keepPreviousData: false,
    refetchOnWindowFocus: false,
    onError: () => {
      notify({
        type: 'error',
        title: translateText('corporateAccounts.invoicesAndStatements.error.title'),
        message: translateText('corporateAccounts.invoicesAndStatements.error'),
      });
    },
  });
};

export const useGetSalesforceInvoiceDocument = invoiceId => {
  const { translateText } = useTranslation();
  const { sendAmplitudeEvent } = useAmplitude();
  const getInvoiceDocument = async () => {
    const result = await getSalesforceInvoiceDocument(invoiceId);
    return result?.data;
  };

  return useQuery({
    queryKey: ['salesforceInvoiceDownload', invoiceId],
    queryFn: getInvoiceDocument,
    enabled: !!invoiceId,
    retry: false,
    cacheTime: 0, // Don't cache downloads
    staleTime: 0, // Always fetch fresh
    keepPreviousData: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    onSuccess: data => {
      convertDataToPDF(data, 'invoice.pdf');
      notify({
        type: 'success',
        message: translateText('corporateAccounts.invoicesAndStatements.modal.success'),
      });
      sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.salesforceInvoicesPageDownloadClicked, {
        'download successful': 'yes',
      });
    },
    onError: () => {
      notify({
        type: 'error',
        message: translateText('corporateAccounts.invoicesAndStatements.modal.error'),
      });
      sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.salesforceInvoicesPageDownloadClicked, {
        'download successful': 'no',
      });
    },
  });
};
